import { useMemo, Dispatch, SetStateAction, memo } from "react";

// Components
import CardDecisionTreeDetail from "./CardDecisionTreeDetail";
// import CardInputFormDetail from "./CardInputFormDetail";

// Types
import {
  FlatNode,
  TreeNode,
  RunSequence,
  SetProp,
  State,
  PickedState,
  DETAIL_CARD_NAME,
} from "./MeFormType";

// Styles
import "./styles/CardMeFormDetail.scss";

// Serializers
import DiagRuleSerializer from "@/issara-sdk/types/DiagRuleSerializer_apps_PRX";
import { Dimmer, Loader } from "semantic-ui-react";

// Type
type CardMeFormDetailProps = {
  runSequence: RunSequence;
  setProp: SetProp;
  MeFormSequence: State["MeFormSequence"];
  languageUX: "en" | "th";
  selectedDivision: any;
  selectedDivisionId: number;

  // data
  selectedNode: TreeNode | null;
  // func
  onSelectNode: Dispatch<SetStateAction<TreeNode | null>>;
  onGoBack: () => void;
  onEditForm: (formDetail?: DiagRuleSerializer) => void;
  onPublishForm: (formDetail?: DiagRuleSerializer) => void;
  onOpenPostBroadcast: (node: FlatNode | TreeNode | null) => void;
  onDuplicateForm: (formDetail?: DiagRuleSerializer) => void;
} & Pick<PickedState, "buttonLoadCheck" | "loadingStatus" | "BillingCreditWallet">;

const CardMeFormDetail = (props: CardMeFormDetailProps) => {
  const formDetail = useMemo(
    () => props.MeFormSequence?.formDetailPage?.formDetail,
    [props.MeFormSequence?.formDetailPage]
  );
  const formType = formDetail?.form_type;

  const handleSelectNode = (node: TreeNode | null) => {
    if (!node) return;

    props.onSelectNode(node);
  };

  const handleEditForm = () => props.onEditForm?.(formDetail);

  const handlePublishForm = () => props.onPublishForm?.(formDetail);

  const handleDuplicateForm = () => props.onDuplicateForm?.(formDetail);

  switch (formType) {
    case "DECISION_TREE": return (
    <CardDecisionTreeDetail
      // data
      formDetail={formDetail}
      pdrNodeList={props.MeFormSequence?.formDetailPage?.pdrNodeList || []}
      broadcastNodeList={props.MeFormSequence?.formDetailPage?.broadcastNodeList || {}}
      patientByLeafList={props.MeFormSequence?.formDetailPage?.patientByLeafList}

      // tree
      selectedNode={props.selectedNode}
      onSelectNode={handleSelectNode}

      // permissions / flags
      isPublished={Boolean(formDetail?.published)}
      isActive={Boolean(formDetail?.active)}

      // Infra
      runSequence={props.runSequence}
      setProp={props.setProp}
      languageUX={props.languageUX}
      selectedDivision={props.selectedDivision}
      
      // Common Infra
      loadingStatus={props.loadingStatus}
      buttonLoadCheck={props.buttonLoadCheck}
      BillingCreditWallet={props.BillingCreditWallet}

      // actions
      onGoBack={props.onGoBack}
      onEditForm={handleEditForm}
      onPublishForm={handlePublishForm}
      onDuplicateForm={handleDuplicateForm}
      onOpenPostBroadcast={props.onOpenPostBroadcast}
    />
  );
    case "INPUT_FORM": return (
    // <CardInputFormDetail
    //   // data
    //   formDetail={formDetail}

    //   // Common Infra
    //   loadingStatus={props.loadingStatus}
    //   buttonLoadCheck={props.buttonLoadCheck}
    //   BillingCreditWallet={props.BillingCreditWallet}

    //   // actions
    //   onGoBack={props.onGoBack}
    // />
  
    <CardDecisionTreeDetail
      // data
      formDetail={formDetail}
      pdrNodeList={props.MeFormSequence?.formDetailPage?.pdrNodeList || []}
      broadcastNodeList={props.MeFormSequence?.formDetailPage?.broadcastNodeList || {}}
      patientByLeafList={props.MeFormSequence?.formDetailPage?.patientByLeafList}

      // tree
      selectedNode={props.selectedNode}
      onSelectNode={handleSelectNode}

      // permissions / flags
      isPublished={Boolean(formDetail?.published)}
      isActive={Boolean(formDetail?.active)}

      // Infra
      runSequence={props.runSequence}
      setProp={props.setProp}
      languageUX={props.languageUX}
      selectedDivision={props.selectedDivision}
      
      // Common Infra
      loadingStatus={props.loadingStatus}
      buttonLoadCheck={props.buttonLoadCheck}
      BillingCreditWallet={props.BillingCreditWallet}

      // actions
      onGoBack={props.onGoBack}
      onEditForm={handleEditForm}
      onPublishForm={handlePublishForm}
      onDuplicateForm={handleDuplicateForm}
      onOpenPostBroadcast={props.onOpenPostBroadcast}
    />
  );

    default: return (
      <div style={{ padding: "15px 0", height: "calc(100vh - 40px)" }}>
        <Dimmer active={props.loadingStatus?.[DETAIL_CARD_NAME]} inverted>
          <Loader inverted>Loading</Loader>
        </Dimmer>
      </div>
    );
  }
};

CardMeFormDetail.displayName = "CardMeFormDetail";

export default memo(CardMeFormDetail);
